import React, { useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { Rnd } from 'react-rnd';
import drawUtils from './drawUtils';
import { Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { FormattedMessage } from 'react-intl';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { LINEAGE_NONE } from './drawConstants';
import TextBoxForSticky from '../../TextBox/TextBoxForSticky';
import LinkBoxForSticky from '../../TextBox/LinkBoxForSticky';
import boardManager from './boardManager';
import {
    BOARD_TYPE,
    COLORS, CONNECTOR_TYPES, SHAPES_SUPPORTING_COLOR, SHAPES_SUPPORTING_TOOL_WIDTH, STROKE_STYLES,
    STICKY_ELEMENTS_TYPE,
    SVG_ELEMENTS_PATH,
    TOOL_CIRCLE,
    TOOL_LINE,
    TOOL_PEN,
    TOOL_RECTANGLE,
} from '../../constants';
import { DeleteForever, MoreVert } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import {
    addLatexToWindowCache,
    addSvgToElemIfExists,
    addSVGToWindowCache,
    getLatexFromWindowCache,
    getSVGFromWindowCache,
} from '../../common/utils';
import convert from 'react-from-dom';
import { updateFunctionGraphText, updateLatexText } from '../../redux/actions';
import functionPlot from './functionPlot';
import store from '../../redux/store';
import LatexEdit from '../../MyComponents/icons/LatexEdit';
import DraggerControl from './DraggerControl';
import apiUtil from '../../Api/apiUtil.js';
import StyledMenu from '../../MyComponents/Drawer/StyledMenu.js';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { CirclePicker } from 'react-color';
import LineSizeSelectorMenu from '../../MyComponents/Drawer/Tools/LineSizeSelectorMenu.js';
import LineWidthIcon from '../../MyComponents/icons/LineWidthIcon.js';
import RotateIconNew from '../../MyComponents/icons/RotateIconNew.js';
import ResizeIcon from '../../MyComponents/icons/ResizeIcon.js';
import RawDraggerControl from './RawDraggerControl.js';

const imagePasteBoxInactive = {
    width: '100%', height: '100%', position: 'relative', boxSizing: 'content-box', borderWidth: '1px',

    borderStyle: 'solid', borderRadius: '2px', boxShadow: '0 0 0 2px #FFFFFF00', borderColor: '#FFFFFF00',
};

// const canvasContainer = {
//     zIndex: '-1000',
//     position: 'absolute',
// };

const imagePasteImg = {
    width: '100%', height: '100%', position: 'relative', touchAction: 'none',
};

const imagePasteImgSelected = {
    width: '100%', height: '100%', position: 'relative', opacity: '0.9', zIndex: '-1', touchAction: 'none',
};

const moverActive = {
    cursor: 'move', zIndex: 0, touchAction: 'none',
};

const lineageStyle = {
    width: '100%',
    height: '100%',
    position: 'absolute',
    backgroundColor: '#fff',
    zIndex: '-1000',
    top: '0px',
    left: '0px',
};

const useStyles = makeStyles(() => ({
    buttonRemoveComponent: {
        position: 'absolute',
        cursor: 'pointer',
        right: '-18px',
        top: '-18px',
        width: '0.7em',
        height: '0.7em',
        transition: 'transform 0.3s',
        '&:hover': {
            // right: '-24px',
            // top: '-24px',
            transform: 'scale(1.8)',
        },
    }, buttonGroup: {
        position: 'absolute', cursor: 'pointer', right: '-24px', top: '-24px',
    }, buttonGroupComponent: {
        width: '0.7em', height: '0.7em', transition: 'transform 0.3s', marginLeft: '0.5rem', '&:hover': {
            // right: '-24px',
            // top: '-24px',
            transform: 'scale(1.8)',
        },
    }, imagePasteBoxSelected: {
        // border: 'solid',
        width: '100%',
        height: '100%',
        position: 'relative',
        borderWidth: '1px',

        borderStyle: 'solid',
        borderRadius: '2px',
        boxShadow: '0 0 0 2px #07767D33',
        borderColor: '#07767D',
        boxSizing: 'content-box',
        lineHeight: '0px',
        touchAction: 'none',

    }, imagePasteBox: {
        // border: 'solid',
        width: '100%',
        height: '100%',
        position: 'relative',
        borderWidth: '1px',

        borderStyle: 'solid',
        borderRadius: '2px',
        boxShadow: '0 0 0 2px #07767D22',
        borderColor: '#FFFFFF22',
        boxSizing: 'content-box',
        '&:hover': {
            borderColor: '#07767D77',
        },
        lineHeight: '0px',
        touchAction: 'none',

    }, menuText: {
        fontWeight: 400,
        fontSize: '0.875rem',
        lineHeight: '1.43rem',
        letterSpacing: '-0.01rem',
        paddingTop: '4px',
        paddingBottom: '4px',
    }, sketchPicker: { padding: '1rem' },
    rotateIcon: {
        color: COLORS.primaryD2,
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        transform: 'translate(-16px, -16px)',
        backgroundColor: COLORS.primaryD2 + 33,
        touchAction: 'none',
    },
}));

const rotateButton = {
    color: COLORS.primaryD2,
    bottom: '32px',
    width: '32px',
    height: '32px',
    right: '40px',
    borderRadius: '50%',
    backgroundColor: COLORS.primaryD2 + 33,
    touchAction: 'none',
};
const resizeButton = {
    color: COLORS.primaryD2,
    bottom: '32px',
    width: '32px',
    height: '32px',
    right: '40px',
    borderRadius: '50%',
    backgroundColor: COLORS.primaryD2 + 33,
    cursor: 'nw-resize',
    touchAction: 'none',
};

function calculateRotationAngle(dragX, dragY, imgX, imgY, imgW, imgH) {
    // 1) find image center
    const cx = imgX + imgW / 2;
    const cy = imgY + imgH / 2;

    // 2) vector from center → handle
    const dx = dragX - cx;
    const dy = dragY - cy;

    // 3) angle in radians, measured from +X axis, positive = CCW
    const radians = Math.atan2(dy, dx);

    // 4) convert to degrees
    let degrees = radians * (180 / Math.PI);

    // 5) normalize to [0…360)
    degrees = (degrees + 360) % 360;

    return degrees;
}


// function getRotatedCenterRight(imgX, imgY, imgW, imgH, angleDeg) {
//     // 1. compute image center
//     const cx = imgX + imgW / 2;
//     const cy = imgY + imgH / 2;
//
//     // 2. local coords of the center‑right relative to center
//     //    (+w/2 to the right, 0 vertically)
//     const localX = imgW / 2;
//     const localY = 0;
//
//     // 3. convert degrees to radians
//     const θ = angleDeg * (Math.PI / 180);
//
//     // 4. rotate by –θ to match CSS’s clockwise‑positive
//     const cos = Math.cos(-θ);
//     const sin = Math.sin(-θ);
//     const rotatedX = localX * cos - localY * sin;
//     const rotatedY = localX * sin + localY * cos;
//
//     // 5. translate back to absolute coords
//     return {
//         x: cx + rotatedX,
//         y: cy + rotatedY,
//     };
// }


const MAIN_MENU = 'MAIN_MENU';
const SIZE_MENU = 'SIZE_MENU';
const COLOR_MENU = 'COLOR_MENU';
const STROKE_STYLE_MENU = 'STROKE_STYLE_MENU';

const MOVEMENT_DEBOUNCE = 20;

const StickyImage = ({
                         reverseScaledPoint,
                         reverseScaledWHPoints,
                         el,
                         isSelectable,
                         setDialogClear,
                         updateStickyImagePosition,
                         startPoint,
                         localSelectedItem,
                         setLocalSelectedItem,
                     }) => {
    const classes = useStyles();
    const [menuState, setMenuState] = useState(null);
    const [anchorMenu, setAnchorMenu] = React.useState(null);
    const [rotation, setRotation] = useState(0);
    const [localWidth, setLocalWidth] = useState(0);
    const [localHeight, setLocalHeight] = useState(0);
    const resizeDebouncer = useRef({ func: null, x: 0, y: 0 });
    const isSVGLoaded = useRef(false);

    let url = el.url;
    let svg = null;
    let strokeWidth = 2;
    if (el.stickyType === STICKY_ELEMENTS_TYPE.SVG && el.path) {
        strokeWidth = drawUtils.computeSVGWidth(el.weight, el.width);
        url = `${SVG_ELEMENTS_PATH}${el.path}`;
        svg = getSVGFromWindowCache(url);
        let idd = `svg-renderer-${el.id}`;

        if (!svg) {
            apiUtil.concurrentURLGet(url).then((res) => {
                svg = res.data;

                addSVGToWindowCache(url, res.data);
                addSvgToElemIfExists(idd, res.data);
            });
        } else {
            addSvgToElemIfExists(idd, svg);
        }
    }
    useEffect(() => {
        if (el.stickyType === STICKY_ELEMENTS_TYPE.SVG && el && el.path && !isSVGLoaded.current) {
            url = `${SVG_ELEMENTS_PATH}${el.path}`;
            svg = getSVGFromWindowCache(url);
            let idd = `svg-renderer-${el.id}`;
            if (svg) {
                let els = document.querySelectorAll('#' + idd);
                els.forEach(ell => {
                    if (ell) {
                        ell.innerHTML = svg;
                    }
                });
                isSVGLoaded.current = true;
            }
        }
    });

    useEffect(() => {
        setLocalWidth(reverseScaledWHPoints.x - reverseScaledPoint.x);
        setLocalHeight(reverseScaledWHPoints.y - reverseScaledPoint.y);
    }, [reverseScaledPoint, reverseScaledWHPoints]);

    useEffect(() => {
        if (!el.path) return;
        url = `${SVG_ELEMENTS_PATH}${el.path}`;
        svg = getSVGFromWindowCache(url);
        let idd = `svg-renderer-${el.id}`;
        if (svg) {
            let els = document.querySelectorAll('#' + idd);
            els.forEach(ell => {
                if (ell) {
                    ell.innerHTML = svg;
                }
            });
            isSVGLoaded.current = true;
        }
    }, [isSelectable]);

    useEffect(() => {
        if (el && el.rotation) {
            setRotation(el.rotation);
        }
    }, [el]);

    const handleClose = () => {
        setAnchorMenu(null);
        setMenuState(null);
    };

    const handleClick = (event) => {
        if (!event) {
            handleClose();
            return;
        }
        setAnchorMenu(event.currentTarget);
        setMenuState(MAIN_MENU);
    };


    const buildRotationPosition = () => {
        let eee = document.getElementById(`rotationPoint-${el.id}`);
        if (!eee) return null;
        let rect = eee.getBoundingClientRect();
        let rect1 = drawUtils.getCurrentCanvasRect();
        return { x: rect.x - rect1.x, y: rect.y - rect1.y };
    };

    const buildResizePosition = () => {
        let eee = document.getElementById(`resizePoint-${el.id}`);
        if (!eee) return null;
        let rect = eee.getBoundingClientRect();
        let rect1 = drawUtils.getCurrentCanvasRect();
        return { x: rect.x - rect1.x, y: rect.y - rect1.y };
    };

    const updateSvgPositionDraggers = () => {
        let rotPoint = buildRotationPosition();
        let resPoint = buildResizePosition();
        if (!rotPoint || !resPoint) return;
        if (setLocalSelectedItem) {
            setLocalSelectedItem(el.id, rotPoint.x - 16, rotPoint.y - 16, resPoint.x - 16, resPoint.y - 16);
        }
    };

    window.updateSvgPositionDraggers = updateSvgPositionDraggers;


    const handleStickyRotationMove = (e, d) => {
        let scaledPoint = drawUtils.scalePoint(startPoint, d.x, d.y);
        let deg = calculateRotationAngle(scaledPoint.x, scaledPoint.y, el.x, el.y, el.width, el.height);
        setRotation(deg);
    };

    const handleStickyRotationStop = () => {
        let eee = document.getElementById(`rotationPoint-${el.id}`);
        if (eee) {
            updateSvgPositionDraggers();
            updateStickyImagePosition(el.id, el.x, el.y, null, null, null, null, rotation);
        }
    };


    const handleStickyResizeMove = (e, d) => {
        // let scaledPoint = drawUtils.scalePoint(startPoint, d.x, d.y);
        // let deg = calculateRotationAngle(scaledPoint.x, scaledPoint.y, el.x, el.y, el.width, el.height);
        // setRotation(deg);

        // let scalePointSize = drawUtils.scalePoint({ x: 0, y: 0 }, ref.offsetWidth, ref.offsetHeight);
        // let scaledPoint = drawUtils.scalePoint(startPoint, position.x, position.y);
        // updateStickyImagePosition(el.id, scaledPoint.x, scaledPoint.y, scalePointSize.x, scalePointSize.y);
        // setLocalSelectedItem(el.id, scaledPoint.x + 16 + el.width, scaledPoint.y - 16 + el.height / 2);
        if (resizeDebouncer.current.func) {
            resizeDebouncer.current.x = d.x;
            resizeDebouncer.current.y = d.y;
        } else {
            resizeDebouncer.current.x = d.x;
            resizeDebouncer.current.y = d.y;
            resizeDebouncer.current.func = setInterval(() => {
                let w = resizeDebouncer.current.x - reverseScaledPoint.x + 16;
                let h = resizeDebouncer.current.y - reverseScaledPoint.y + 16;
                if (w > 10 && h > 10) {
                    setLocalWidth(Math.max(h, w));
                    setLocalHeight(Math.max(h, w));
                }
            }, MOVEMENT_DEBOUNCE);
        }
    };

    const handleStickyResizeStop = (e, d) => {
        if (resizeDebouncer.current.func) {
            clearInterval(resizeDebouncer.current.func);
            resizeDebouncer.current.func = null;
        }
        resizeDebouncer.current.x = d.x;
        resizeDebouncer.current.y = d.y;
        let w = resizeDebouncer.current.x - reverseScaledPoint.x + 16;
        let h = resizeDebouncer.current.y - reverseScaledPoint.y + 16;
        let localS = Math.max(h, w);
        if (w > 10 && h > 10) {
            setLocalWidth(localS);
            setLocalHeight(localS);
        }
        let s = drawUtils.scalePoint({ x: 0, y: 0 }, localS, localS);
        updateStickyImagePosition(el.id, el.x, el.y, s.x, s.x);
    };

    useEffect(() => {
        if (localSelectedItem === el.id) {
            setTimeout(() => {
                if (el.stickyType === STICKY_ELEMENTS_TYPE.SVG) {
                    updateSvgPositionDraggers();
                } else {
                    setLocalSelectedItem(el.id);
                }
            }, MOVEMENT_DEBOUNCE);
        }
    }, [localSelectedItem, el.x, el.y, el.width, el.height, el.rotation]);

    if (localSelectedItem === el.id) {
        window.handleStickyRotationMove = handleStickyRotationMove;
        window.handleStickyRotationStop = handleStickyRotationStop;
        window.handleStickyResizeMove = handleStickyResizeMove;
        window.handleStickyResizeStop = handleStickyResizeStop;
    }

    const buildDefaultMenu = () => {
        let topMenu = null;
        let subMenu = null;
        if (el.stickyType === STICKY_ELEMENTS_TYPE.IMAGE) {
            return (<DeleteForever
                color='secondary'
                className={classes.buttonRemoveComponent}
                onClick={() => {
                    setDialogClear(el.id);
                }}
                onTouchStart={() => {
                    setDialogClear(el.id);
                }}
                style={{ display: localSelectedItem === el.id ? 'block' : 'none' }}
            />);
        } else {
            let canChangeColor = SHAPES_SUPPORTING_COLOR.includes(el.path);
            let canChangeWidth = SHAPES_SUPPORTING_TOOL_WIDTH.includes(el.path);
            if (menuState === SIZE_MENU) {
                subMenu = (<LineSizeSelectorMenu
                    toolWeight={el.weight}
                    selectWeight={(size) => {
                        updateStickyImagePosition(el.id, null, null, null, null, size, null);
                        handleClose();
                    }}
                />);
            } else if (menuState === COLOR_MENU) {
                subMenu = (<div className={classes.sketchPicker}>
                    <CirclePicker
                        disableAlpha
                        color={el.color}
                        colors={['#000000', '#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3', '#03a9f4', '#009688', '#4caf50', '#8bc34a', '#cddc39', '#ffeb3b', '#ffc107', '#ff9800', '#ff5722', '#795548', '#607d8b']}
                        onChangeComplete={(c) => {
                            updateStickyImagePosition(el.id, null, null, null, null, null, c.hex);
                            handleClose();
                        }}
                    />
                </div>);
            } else if (canChangeColor || canChangeWidth) {
                subMenu = (<List>
                    <ListItem
                        button
                        onClick={(e) => {
                            setDialogClear(el.id);
                            e.stopPropagation();
                        }}
                        className={classes.menuText}
                    >
                        <ListItemIcon>
                            <DeleteForever color='secondary' />
                        </ListItemIcon>
                        <FormattedMessage id='tooltip.lessonPage.remove' />
                    </ListItem>
                    {canChangeWidth ? (<ListItem
                        button
                        onClick={(e) => {
                            setMenuState(SIZE_MENU);
                            e.stopPropagation();
                        }}
                        className={classes.menuText}
                    >
                        <ListItemIcon>
                            <LineWidthIcon style={{ verticalAlign: 'middle' }} color={'primary'} />
                        </ListItemIcon>
                        <FormattedMessage id='tooltip.lessonPage.size' />
                    </ListItem>) : null}
                    {canChangeColor ? (<ListItem
                        button
                        onClick={(e) => {
                            setMenuState(COLOR_MENU);
                            e.stopPropagation();
                        }}
                        className={classes.menuText}
                    >
                        <ListItemIcon>
                        <span
                            style={{
                                borderRadius: '50%',
                                display: 'inline-block',
                                border: '1px solid white',
                                background: el.color,
                                width: '24px',
                                height: '24px',
                            }}
                        />
                        </ListItemIcon>
                        <FormattedMessage id='tooltip.lessonPage.color' />
                    </ListItem>) : null}
                </List>);
            } else {
                return (<DeleteForever
                    color='secondary'
                    className={classes.buttonRemoveComponent}
                    onClick={() => {
                        setDialogClear(el.id);
                    }}
                    onTouchStart={() => {
                        setDialogClear(el.id);
                    }}
                    style={{ display: localSelectedItem === el.id ? 'block' : 'none' }}
                />);
            }
            topMenu = <div style={{ display: localSelectedItem === el.id ? 'block' : 'none' }}>
                <MoreVert
                    color='primary'
                    onClick={(e) => {
                        // props.setDialogClear(props.id);
                        handleClick(e);
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                    onTouchStart={(e) => {
                        // props.setDialogClear(props.id);
                        handleClick(e);
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                    className={classes.buttonRemoveComponent}
                />
                <StyledMenu
                    id={`svg-edit-${el.id}`}
                    anchorEl={anchorMenu}
                    keepMounted
                    open={Boolean(anchorMenu)}
                    onClose={handleClose}
                >
                    {subMenu}
                </StyledMenu>
            </div>;
        }
        return topMenu;
    };

    if (isSelectable) {
        let menu = buildDefaultMenu();
        // if (menuState === SIZE_MENU) {
        //     menu = (<LineSizeSelectorMenu
        //         toolWeight={el.weight}
        //         selectWeight={(size) => {
        //             updateStickyImagePosition(el.id, null, null, null, null, size, null);
        //             handleClose();
        //         }}
        //     />);
        // }
        // if (menuState === COLOR_MENU) {
        //     menu = (<div className={classes.sketchPicker}>
        //         <CirclePicker
        //             disableAlpha
        //             color={el.color}
        //             colors={['#000000', '#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3', '#03a9f4', '#009688', '#4caf50', '#8bc34a', '#cddc39', '#ffeb3b', '#ffc107', '#ff9800', '#ff5722', '#795548', '#607d8b']}
        //             onChangeComplete={(c) => {
        //                 updateStickyImagePosition(el.id, null, null, null, null, null, c.hex);
        //                 handleClose();
        //             }}
        //         />
        //     </div>);
        // }

        return (<Rnd
            key={'stickyImage-' + el.id}
            position={{
                x: reverseScaledPoint.x, y: reverseScaledPoint.y,
            }}
            size={{
                width: localWidth,
                height: localHeight,
            }}
            bounds='parent'
            dragAxis='both'
            onDragStop={(e, d) => {
                let scaledPoint = drawUtils.scalePoint(startPoint, d.x, d.y);
                if (el.stickyType !== STICKY_ELEMENTS_TYPE.SVG) {
                    if (el.x !== scaledPoint.x || el.y !== scaledPoint.y) {
                        updateStickyImagePosition(el.id, scaledPoint.x, scaledPoint.y);
                        setLocalSelectedItem(el.id);
                    }
                } else {
                    // updateStickyImagePosition(el.id, scaledPoint.x, scaledPoint.y);
                    updateSvgPositionDraggers();
                    updateStickyImagePosition(el.id, scaledPoint.x, scaledPoint.y);
                }
            }}
            onResizeStop={(e, direction, ref, delta, position) => {
                let scalePointSize = drawUtils.scalePoint({ x: 0, y: 0 }, ref.offsetWidth, ref.offsetHeight);
                let scaledPoint = drawUtils.scalePoint(startPoint, position.x, position.y);
                updateStickyImagePosition(el.id, scaledPoint.x, scaledPoint.y, scalePointSize.x, scalePointSize.y);
                setLocalSelectedItem(el.id, scaledPoint.x + 16 + el.width, scaledPoint.y - 16 + el.height / 2);
            }}
            style={moverActive}
            onTouchStart={(e) => {
                // e.stopPropagation();
                if (el.stickyType !== STICKY_ELEMENTS_TYPE.SVG) {
                    setLocalSelectedItem(el.id);
                    updateStickyImagePosition(el.id, el.x, el.y);
                } else {
                    // let rotPoint = buildRotationPosition();
                    // let resPoint = buildResizePosition();
                    // setLocalSelectedItem(el.id, rotPoint.x - 20, rotPoint.y - 20, resPoint.x - 20, resPoint.y - 20);
                    // updateStickyImagePosition(el.id, el.x, el.y);
                }
            }}
            onPointerDown={(e) => {
                // e.stopPropagation();
                if (el.stickyType !== STICKY_ELEMENTS_TYPE.SVG) {
                    setLocalSelectedItem(el.id);
                    updateStickyImagePosition(el.id, el.x, el.y);
                } else {
                    // let rotPoint = buildRotationPosition();
                    // let resPoint = buildResizePosition();
                    // setLocalSelectedItem(el.id, rotPoint.x - 20, rotPoint.y - 20, resPoint.x - 20, resPoint.y - 20);
                    // updateStickyImagePosition(el.id, el.x, el.y);
                }
            }}
            lockAspectRatio={el.stickyType === STICKY_ELEMENTS_TYPE.SVG ? 1 : false}
            enableResizing={el.stickyType !== STICKY_ELEMENTS_TYPE.SVG}
        >
            <div className={localSelectedItem === el.id ? classes.imagePasteBoxSelected : classes.imagePasteBox}>
                {el.stickyType === STICKY_ELEMENTS_TYPE.SVG ?
                    <>
                        <div style={{ position: 'relative', transform: `rotate(${rotation}deg)` }}>
                            <div id={`svg-renderer-${el.id}`}
                                 style={{
                                     color: el.color,
                                     strokeWidth: strokeWidth,
                                     fill: el.color,
                                 }}>
                            </div>
                            <div id={`rotationPoint-${el.id}`}
                                 style={{
                                     position: 'absolute',
                                     backgroundColor: 'green',
                                     width: '1px',
                                     height: '1px',
                                     top: '50%',
                                     right: '-32px',
                                     display: localSelectedItem === el.id ? 'block' : 'none',
                                 }}>
                                <RotateIconNew
                                    className={classes.rotateIcon}
                                />
                            </div>
                        </div>
                        <div id={`resizePoint-${el.id}`}
                             style={{
                                 position: 'absolute',
                                 backgroundColor: 'green',
                                 width: '1px',
                                 height: '1px',
                                 bottom: '0px',
                                 right: '0px',
                                 display: localSelectedItem === el.id ? 'block' : 'none',
                             }}>
                            <ResizeIcon
                                className={classes.rotateIcon}
                            />
                        </div>

                    </>
                    :
                    <img src={url} alt='' style={{ ...imagePasteImgSelected, transform: `rotate(${rotation}deg)` }} />}

                {menu}
                {/*{el.stickyType === STICKY_ELEMENTS_TYPE.SVG ? (*/}
                {/*    <div style={{ display: localSelectedItem === el.id ? 'block' : 'none' }}>*/}
                {/*        <MoreVert*/}
                {/*            color='primary'*/}
                {/*            onClick={(e) => {*/}
                {/*                // props.setDialogClear(props.id);*/}
                {/*                handleClick(e);*/}
                {/*                e.preventDefault();*/}
                {/*                e.stopPropagation();*/}
                {/*            }}*/}
                {/*            onTouchStart={(e) => {*/}
                {/*                // props.setDialogClear(props.id);*/}
                {/*                handleClick(e);*/}
                {/*                e.preventDefault();*/}
                {/*                e.stopPropagation();*/}
                {/*            }}*/}
                {/*            className={classes.buttonRemoveComponent}*/}
                {/*        />*/}
                {/*        <StyledMenu*/}
                {/*            id={`svg-edit-${el.id}`}*/}
                {/*            anchorEl={anchorMenu}*/}
                {/*            keepMounted*/}
                {/*            open={Boolean(anchorMenu)}*/}
                {/*            onClose={handleClose}*/}
                {/*        >*/}
                {/*            {menu}*/}
                {/*        </StyledMenu>*/}
                {/*    </div>) : <DeleteForever*/}
                {/*    color='secondary'*/}
                {/*    className={classes.buttonRemoveComponent}*/}
                {/*    onClick={() => {*/}
                {/*        setDialogClear(el.id);*/}
                {/*    }}*/}
                {/*    onTouchStart={() => {*/}
                {/*        setDialogClear(el.id);*/}
                {/*    }}*/}
                {/*    style={{ display: localSelectedItem === el.id ? 'block' : 'none' }}*/}
                {/*/>}*/}


            </div>
        </Rnd>);
    } else {
        let style = {
            ...imagePasteBoxInactive,
            color: el.color,
            strokeWidth: strokeWidth,
            fill: el.color,
            transform: `rotate(${rotation}deg)`,
        };
        style.position = 'absolute';
        style.top = reverseScaledPoint.y + 'px';
        style.left = reverseScaledPoint.x + 'px';
        style.width = reverseScaledWHPoints.x - reverseScaledPoint.x;
        style.height = reverseScaledWHPoints.y - reverseScaledPoint.y;
        style.zIndex = '-1000';
        return (<div style={style}
                     id={`${el.stickyType === STICKY_ELEMENTS_TYPE.SVG ? 'svg-renderer' : 'img-renderer'}-${el.id}`}>
            {el.stickyType === STICKY_ELEMENTS_TYPE.SVG ? null : <img src={url} alt='' style={imagePasteImg} />}
        </div>);
    }
};

const StickyLatex = ({
                         reverseScaledPoint,
                         reverseScaledWHPoints,
                         el,
                         isSelectable,
                         setDialogClear,
                         updateLatexCallback,
                         updateStickyImagePosition,
                         startPoint,
                         localSelectedItem,
                         setLocalSelectedItem,
                     }) => {
    const classes = useStyles();
    let ltx = getLatexFromWindowCache(el.id);
    if (!ltx) {
        ltx = window.latexToImg(el.latex);
        addLatexToWindowCache(el.id, ltx);
    }

    if (isSelectable) {
        return (<Rnd
            key={'stickyLatex-' + el.id}
            position={{
                x: reverseScaledPoint.x, y: reverseScaledPoint.y,
            }}
            size={{
                width: reverseScaledWHPoints.x - reverseScaledPoint.x,
                height: reverseScaledWHPoints.y - reverseScaledPoint.y,
            }}
            bounds='parent'
            dragAxis='both'
            onDragStop={(e, d) => {
                let scaledPoint = drawUtils.scalePoint(startPoint, d.x, d.y);
                updateStickyImagePosition(el.id, scaledPoint.x, scaledPoint.y);
                setLocalSelectedItem(el.id);

                // this.setState({ x: d.x, y: d.y });
            }}
            onResizeStop={(e, direction, ref, delta, position) => {
                let scalePointSize = drawUtils.scalePoint({ x: 0, y: 0 }, ref.offsetWidth, ref.offsetHeight);
                let scaledPoint = drawUtils.scalePoint(startPoint, position.x, position.y);
                updateStickyImagePosition(el.id, scaledPoint.x, scaledPoint.y, scalePointSize.x, scalePointSize.y);
                setLocalSelectedItem(el.id);
            }}
            style={moverActive}
            onTouchStart={(e) => {
                e.stopPropagation();
            }}
            onPointerDown={(e) => {
                e.stopPropagation();
            }}
        >
            <div
                className={localSelectedItem === el.id ? classes.imagePasteBoxSelected : classes.imagePasteBox}
                style={{ color: el.color }}>
                {convert(ltx)}
                <div className={classes.buttonGroup}
                     style={{ display: localSelectedItem === el.id ? 'block' : 'none' }}>
                    <LatexEdit
                        color='primary'
                        className={classes.buttonGroupComponent}
                        onClick={() => {
                            store.dispatch(updateLatexText({ el, callback: updateLatexCallback }));
                            setLocalSelectedItem(el.id);
                        }}
                        onTouchStart={() => {
                            store.dispatch(updateLatexText({ el, callback: updateLatexCallback }));
                            setLocalSelectedItem(el.id);
                        }}
                    />
                    <DeleteForever
                        color='secondary'
                        className={classes.buttonGroupComponent}
                        onClick={() => {
                            setDialogClear(el.id);
                        }}
                        onTouchStart={() => {
                            setDialogClear(el.id);
                        }}
                    />
                </div>
            </div>
        </Rnd>);
    } else {
        let style = { ...imagePasteBoxInactive };
        style.position = 'absolute';
        style.top = reverseScaledPoint.y + 'px';
        style.left = reverseScaledPoint.x + 'px';
        style.width = reverseScaledWHPoints.x - reverseScaledPoint.x;
        style.height = reverseScaledWHPoints.y - reverseScaledPoint.y;
        style.zIndex = '-1000';
        style.color = el.color;
        return <div style={style}>{convert(ltx)}</div>;
    }
};

const StickyEmbeddedSvg = ({
                               reverseScaledPoint,
                               reverseScaledWHPoints,
                               el,
                               isSelectable,
                               setDialogClear,
                               updateStickyImagePosition,
                               startPoint,
                               localSelectedItem,
                               setLocalSelectedItem,
                           }) => {
    const classes = useStyles();

    if (isSelectable) {
        return (<Rnd
            key={'stickyEmbeddedSvg-' + el.id}
            position={{
                x: reverseScaledPoint.x, y: reverseScaledPoint.y,
            }}
            size={{
                width: reverseScaledWHPoints.x - reverseScaledPoint.x,
                height: reverseScaledWHPoints.y - reverseScaledPoint.y,
            }}
            bounds='parent'
            dragAxis='both'
            onDragStop={(e, d) => {
                let scaledPoint = drawUtils.scalePoint(startPoint, d.x, d.y);
                updateStickyImagePosition(el.id, scaledPoint.x, scaledPoint.y);
                setLocalSelectedItem(el.id);
            }}
            onResizeStop={(e, direction, ref, delta, position) => {
                let scalePointSize = drawUtils.scalePoint({ x: 0, y: 0 }, ref.offsetWidth, ref.offsetHeight);
                let scaledPoint = drawUtils.scalePoint(startPoint, position.x, position.y);
                updateStickyImagePosition(el.id, scaledPoint.x, scaledPoint.y, scalePointSize.x, scalePointSize.y);
                setLocalSelectedItem(el.id);
            }}
            lockAspectRatio={true}
            style={moverActive}
            onTouchStart={(e) => {
                e.stopPropagation();
            }}
            onPointerDown={(e) => {
                e.stopPropagation();
            }}
        >
            <div
                className={localSelectedItem === el.id ? classes.imagePasteBoxSelected : classes.imagePasteBox}
                style={{ color: el.color }}>
                <div dangerouslySetInnerHTML={{ __html: el.svgContent }} />
                <div className={classes.buttonGroup}
                     style={{ display: localSelectedItem === el.id ? 'block' : 'none' }}>
                    <DeleteForever
                        color='secondary'
                        className={classes.buttonGroupComponent}
                        onClick={() => {
                            setDialogClear(el.id);
                        }}
                        onTouchStart={() => {
                            setDialogClear(el.id);
                        }}
                    />
                </div>
            </div>
        </Rnd>);
    } else {
        let style = { ...imagePasteBoxInactive };
        style.position = 'absolute';
        style.top = reverseScaledPoint.y + 'px';
        style.left = reverseScaledPoint.x + 'px';
        style.width = reverseScaledWHPoints.x - reverseScaledPoint.x;
        style.height = reverseScaledWHPoints.y - reverseScaledPoint.y;
        style.zIndex = '-1000';
        style.color = el.color;
        return <div style={style} dangerouslySetInnerHTML={{ __html: el.svgContent }} />;
    }
};

const StickyFunctionGraph = ({
                                 reverseScaledPoint,
                                 reverseScaledWHPoints,
                                 el,
                                 isSelectable,
                                 setDialogClear,
                                 updateFunctionGraphCallback,
                                 updateStickyImagePosition,
                                 startPoint,
                                 localSelectedItem,
                                 setLocalSelectedItem,
                             }) => {
    const classes = useStyles();
    // The 2D curve uses currentColor via the wrapper's style.color; the 3D
    // surface bakes shaded fills derived from el.color into the SVG string,
    // hence el.color in the deps.
    const svg = useMemo(
        () => functionPlot.buildFunctionGraphSvg(el),
        [el.expression, el.xMin, el.xMax, el.yMin, el.yMax, el.azimuth, el.elevation, el.color, el.weight], // eslint-disable-line react-hooks/exhaustive-deps
    );

    if (isSelectable) {
        return (<Rnd
            key={'stickyFunctionGraph-' + el.id}
            position={{
                x: reverseScaledPoint.x, y: reverseScaledPoint.y,
            }}
            size={{
                width: reverseScaledWHPoints.x - reverseScaledPoint.x,
                height: reverseScaledWHPoints.y - reverseScaledPoint.y,
            }}
            bounds='parent'
            dragAxis='both'
            onDragStop={(e, d) => {
                let scaledPoint = drawUtils.scalePoint(startPoint, d.x, d.y);
                updateStickyImagePosition(el.id, scaledPoint.x, scaledPoint.y);
                setLocalSelectedItem(el.id);
            }}
            onResizeStop={(e, direction, ref, delta, position) => {
                let scalePointSize = drawUtils.scalePoint({ x: 0, y: 0 }, ref.offsetWidth, ref.offsetHeight);
                let scaledPoint = drawUtils.scalePoint(startPoint, position.x, position.y);
                updateStickyImagePosition(el.id, scaledPoint.x, scaledPoint.y, scalePointSize.x, scalePointSize.y);
                setLocalSelectedItem(el.id);
            }}
            lockAspectRatio={true}
            style={moverActive}
            onTouchStart={(e) => {
                e.stopPropagation();
            }}
            onPointerDown={(e) => {
                e.stopPropagation();
            }}
        >
            <div
                className={localSelectedItem === el.id ? classes.imagePasteBoxSelected : classes.imagePasteBox}
                style={{ color: el.color }}>
                <div dangerouslySetInnerHTML={{ __html: svg }} style={{ width: '100%', height: '100%' }} />
                <div className={classes.buttonGroup}
                     style={{ display: localSelectedItem === el.id ? 'block' : 'none' }}>
                    <LatexEdit
                        color='primary'
                        className={classes.buttonGroupComponent}
                        onClick={() => {
                            store.dispatch(updateFunctionGraphText({ el, callback: updateFunctionGraphCallback }));
                            setLocalSelectedItem(el.id);
                        }}
                        onTouchStart={() => {
                            store.dispatch(updateFunctionGraphText({ el, callback: updateFunctionGraphCallback }));
                            setLocalSelectedItem(el.id);
                        }}
                    />
                    <DeleteForever
                        color='secondary'
                        className={classes.buttonGroupComponent}
                        onClick={() => {
                            setDialogClear(el.id);
                        }}
                        onTouchStart={() => {
                            setDialogClear(el.id);
                        }}
                    />
                </div>
            </div>
        </Rnd>);
    } else {
        let style = { ...imagePasteBoxInactive };
        style.position = 'absolute';
        style.top = reverseScaledPoint.y + 'px';
        style.left = reverseScaledPoint.x + 'px';
        style.width = reverseScaledWHPoints.x - reverseScaledPoint.x;
        style.height = reverseScaledWHPoints.y - reverseScaledPoint.y;
        style.zIndex = '-1000';
        style.color = el.color;
        return <div style={style} dangerouslySetInnerHTML={{ __html: svg }} />;
    }
};

const CONNECTOR_PADDING = 20;
const CONNECTOR_MIN_BOX = 40;

const StickyConnector = ({
                             el,
                             isSelectable,
                             setDialogClear,
                             updateConnectorPosition,
                             startPoint,
                             localSelectedItem,
                             setLocalSelectedItem,
                             email,
                         }) => {
    const classes = useStyles();
    const [menuState, setMenuState] = useState(null);
    const [anchorMenu, setAnchorMenu] = React.useState(null);
    const [localX1, setLocalX1] = useState(el.x1);
    const [localY1, setLocalY1] = useState(el.y1);
    const [localX2, setLocalX2] = useState(el.x2);
    const [localY2, setLocalY2] = useState(el.y2);

    useEffect(() => {
        setLocalX1(el.x1);
        setLocalY1(el.y1);
        setLocalX2(el.x2);
        setLocalY2(el.y2);
    }, [el.x1, el.y1, el.x2, el.y2]);

    const handleMenuClose = () => {
        setAnchorMenu(null);
        setMenuState(null);
    };

    const handleMenuClick = (event) => {
        if (!event) {
            handleMenuClose();
            return;
        }
        setAnchorMenu(event.currentTarget);
        setMenuState(MAIN_MENU);
    };

    // Compute bounding box
    const minX = Math.min(localX1, localX2);
    const minY = Math.min(localY1, localY2);
    const maxX = Math.max(localX1, localX2);
    const maxY = Math.max(localY1, localY2);

    const rawW = maxX - minX;
    const rawH = maxY - minY;
    const boxW = Math.max(rawW, CONNECTOR_MIN_BOX) + CONNECTOR_PADDING * 2;
    const boxH = Math.max(rawH, CONNECTOR_MIN_BOX) + CONNECTOR_PADDING * 2;

    // Offset so the line is centered in the padded box
    const offsetX = minX - CONNECTOR_PADDING - (Math.max(rawW, CONNECTOR_MIN_BOX) - rawW) / 2;
    const offsetY = minY - CONNECTOR_PADDING - (Math.max(rawH, CONNECTOR_MIN_BOX) - rawH) / 2;

    // Points relative to SVG box
    const svgX1 = localX1 - offsetX;
    const svgY1 = localY1 - offsetY;
    const svgX2 = localX2 - offsetX;
    const svgY2 = localY2 - offsetY;

    // Reverse scale for screen positioning
    let screenPos = drawUtils.reverseScalePoint(startPoint, offsetX, offsetY);
    let screenEnd = drawUtils.reverseScalePoint(startPoint, offsetX + boxW, offsetY + boxH);
    if (!screenPos) screenPos = drawUtils.reverseScalePoint(startPoint, offsetX, offsetY, email);
    if (!screenEnd) screenEnd = drawUtils.reverseScalePoint(startPoint, offsetX + boxW, offsetY + boxH, email);

    if (!screenPos || !screenEnd) return null;

    const screenW = screenEnd.x - screenPos.x;
    const screenH = screenEnd.y - screenPos.y;

    // Scale factors for SVG coordinates to screen
    const scaleX = screenW / boxW;
    const scaleY = screenH / boxH;

    const weight = el.weight || 3;
    const color = el.color || '#000000';

    // Stroke dasharray
    let dashArray = 'none';
    if (el.strokeStyle === STROKE_STYLES.DASHED) {
        dashArray = `${weight * 3} ${weight * 2}`;
    } else if (el.strokeStyle === STROKE_STYLES.DOTTED) {
        dashArray = `${weight} ${weight * 1.5}`;
    }

    const hasEndArrow = el.connectorType !== CONNECTOR_TYPES.LINE;
    const hasStartArrow = el.connectorType === CONNECTOR_TYPES.DOUBLE_ARROW_OPEN || el.connectorType === CONNECTOR_TYPES.DOUBLE_ARROW_FILLED;
    const isFilledArrow = el.connectorType === CONNECTOR_TYPES.ARROW_FILLED || el.connectorType === CONNECTOR_TYPES.DOUBLE_ARROW_FILLED;

    const isSelected = localSelectedItem === el.id;

    // Handle line body drag
    const handleLinePointerDown = (e) => {
        if (!isSelectable) return;
        e.preventDefault();
        e.stopPropagation();
        setLocalSelectedItem(el.id);

        const startClientX = e.clientX;
        const startClientY = e.clientY;
        const origX1 = localX1;
        const origY1 = localY1;
        const origX2 = localX2;
        const origY2 = localY2;

        const handlePointerMove = (ev) => {
            const dx = (ev.clientX - startClientX) / scaleX;
            const dy = (ev.clientY - startClientY) / scaleY;
            setLocalX1(origX1 + dx);
            setLocalY1(origY1 + dy);
            setLocalX2(origX2 + dx);
            setLocalY2(origY2 + dy);
        };

        const handlePointerUp = (ev) => {
            document.removeEventListener('pointermove', handlePointerMove);
            document.removeEventListener('pointerup', handlePointerUp);
            const dx = (ev.clientX - startClientX) / scaleX;
            const dy = (ev.clientY - startClientY) / scaleY;
            const newX1 = origX1 + dx;
            const newY1 = origY1 + dy;
            const newX2 = origX2 + dx;
            const newY2 = origY2 + dy;
            setLocalX1(newX1);
            setLocalY1(newY1);
            setLocalX2(newX2);
            setLocalY2(newY2);
            updateConnectorPosition(el.id, newX1, newY1, newX2, newY2, null, null, null, null);
        };

        document.addEventListener('pointermove', handlePointerMove);
        document.addEventListener('pointerup', handlePointerUp);
    };

    // Handle endpoint drag
    const handleEndpointDrag = (endpoint, e) => {
        if (!isSelectable) return;
        e.preventDefault();
        e.stopPropagation();
        setLocalSelectedItem(el.id);

        const startClientX = e.clientX;
        const startClientY = e.clientY;
        const origVal = endpoint === 1
            ? { x: localX1, y: localY1 }
            : { x: localX2, y: localY2 };

        const handlePointerMove = (ev) => {
            const dx = (ev.clientX - startClientX) / scaleX;
            const dy = (ev.clientY - startClientY) / scaleY;
            if (endpoint === 1) {
                setLocalX1(origVal.x + dx);
                setLocalY1(origVal.y + dy);
            } else {
                setLocalX2(origVal.x + dx);
                setLocalY2(origVal.y + dy);
            }
        };

        const handlePointerUp = (ev) => {
            document.removeEventListener('pointermove', handlePointerMove);
            document.removeEventListener('pointerup', handlePointerUp);
            const dx = (ev.clientX - startClientX) / scaleX;
            const dy = (ev.clientY - startClientY) / scaleY;
            let newX1 = localX1, newY1 = localY1, newX2 = localX2, newY2 = localY2;
            if (endpoint === 1) {
                newX1 = origVal.x + dx;
                newY1 = origVal.y + dy;
                setLocalX1(newX1);
                setLocalY1(newY1);
            } else {
                newX2 = origVal.x + dx;
                newY2 = origVal.y + dy;
                setLocalX2(newX2);
                setLocalY2(newY2);
            }
            updateConnectorPosition(el.id, newX1, newY1, newX2, newY2, null, null, null, null);
        };

        document.addEventListener('pointermove', handlePointerMove);
        document.addEventListener('pointerup', handlePointerUp);
    };

    // Build context menu
    let menuContent = null;
    if (isSelected && isSelectable) {
        let subMenu = null;
        if (menuState === SIZE_MENU) {
            subMenu = (
                <LineSizeSelectorMenu
                    toolWeight={el.weight}
                    selectWeight={(size) => {
                        updateConnectorPosition(el.id, null, null, null, null, size, null, null, null);
                        handleMenuClose();
                    }}
                />
            );
        } else if (menuState === COLOR_MENU) {
            subMenu = (
                <div className={classes.sketchPicker}>
                    <CirclePicker
                        disableAlpha
                        color={el.color}
                        colors={['#000000', '#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3', '#03a9f4', '#009688', '#4caf50', '#8bc34a', '#cddc39', '#ffeb3b', '#ffc107', '#ff9800', '#ff5722', '#795548', '#607d8b']}
                        onChangeComplete={(c) => {
                            updateConnectorPosition(el.id, null, null, null, null, null, c.hex, null, null);
                            handleMenuClose();
                        }}
                    />
                </div>
            );
        } else if (menuState === STROKE_STYLE_MENU) {
            subMenu = (
                <List>
                    <ListItem button onClick={() => {
                        updateConnectorPosition(el.id, null, null, null, null, null, null, null, STROKE_STYLES.SOLID);
                        handleMenuClose();
                    }} className={classes.menuText}>
                        <ListItemIcon>
                            <svg width='24' height='24'>
                                <line x1='2' y1='12' x2='22' y2='12' stroke='currentColor' strokeWidth='2' />
                            </svg>
                        </ListItemIcon>
                        <FormattedMessage id='connector.style.solid' defaultMessage='Solid' />
                    </ListItem>
                    <ListItem button onClick={() => {
                        updateConnectorPosition(el.id, null, null, null, null, null, null, null, STROKE_STYLES.DASHED);
                        handleMenuClose();
                    }} className={classes.menuText}>
                        <ListItemIcon>
                            <svg width='24' height='24'>
                                <line x1='2' y1='12' x2='22' y2='12' stroke='currentColor' strokeWidth='2'
                                      strokeDasharray='6 4' />
                            </svg>
                        </ListItemIcon>
                        <FormattedMessage id='connector.style.dashed' defaultMessage='Dashed' />
                    </ListItem>
                    <ListItem button onClick={() => {
                        updateConnectorPosition(el.id, null, null, null, null, null, null, null, STROKE_STYLES.DOTTED);
                        handleMenuClose();
                    }} className={classes.menuText}>
                        <ListItemIcon>
                            <svg width='24' height='24'>
                                <line x1='2' y1='12' x2='22' y2='12' stroke='currentColor' strokeWidth='2'
                                      strokeDasharray='2 3' />
                            </svg>
                        </ListItemIcon>
                        <FormattedMessage id='connector.style.dotted' defaultMessage='Dotted' />
                    </ListItem>
                </List>
            );
        } else {
            subMenu = (
                <List>
                    <ListItem
                        button
                        onClick={(e) => {
                            setDialogClear(el.id);
                            e.stopPropagation();
                        }}
                        className={classes.menuText}
                    >
                        <ListItemIcon>
                            <DeleteForever color='secondary' />
                        </ListItemIcon>
                        <FormattedMessage id='tooltip.lessonPage.remove' />
                    </ListItem>
                    <ListItem
                        button
                        onClick={(e) => {
                            setMenuState(COLOR_MENU);
                            e.stopPropagation();
                        }}
                        className={classes.menuText}
                    >
                        <ListItemIcon>
                            <span
                                style={{
                                    borderRadius: '50%',
                                    display: 'inline-block',
                                    border: '1px solid white',
                                    background: el.color || '#000',
                                    width: '24px',
                                    height: '24px',
                                }}
                            />
                        </ListItemIcon>
                        <FormattedMessage id='tooltip.lessonPage.color' />
                    </ListItem>
                    <ListItem
                        button
                        onClick={(e) => {
                            setMenuState(SIZE_MENU);
                            e.stopPropagation();
                        }}
                        className={classes.menuText}
                    >
                        <ListItemIcon>
                            <LineWidthIcon style={{ verticalAlign: 'middle' }} color={'primary'} />
                        </ListItemIcon>
                        <FormattedMessage id='tooltip.lessonPage.size' />
                    </ListItem>
                    <ListItem
                        button
                        onClick={(e) => {
                            setMenuState(STROKE_STYLE_MENU);
                            e.stopPropagation();
                        }}
                        className={classes.menuText}
                    >
                        <ListItemIcon>
                            <svg width='24' height='24'>
                                <line x1='2' y1='12' x2='22' y2='12' stroke='currentColor' strokeWidth='2'
                                      strokeDasharray='6 4' />
                            </svg>
                        </ListItemIcon>
                        <FormattedMessage id='connector.lineStyle' defaultMessage='Line Style' />
                    </ListItem>
                </List>
            );
        }

        // Position menu icon at the midpoint of the line, slightly above
        const midX = (localX1 + localX2) / 2;
        const midY = (localY1 + localY2) / 2;
        let midScreen = drawUtils.reverseScalePoint(startPoint, midX, midY);
        if (!midScreen) midScreen = drawUtils.reverseScalePoint(startPoint, midX, midY, email);
        const menuLeft = midScreen ? midScreen.x - screenPos.x - 24 : 0;
        const menuTop = midScreen ? midScreen.y - screenPos.y - 30 : 0;

        menuContent = (
            <div style={{ position: 'absolute', left: menuLeft, top: menuTop, zIndex: 10, pointerEvents: 'auto' }}>
                <MoreVert
                    color='primary'
                    style={{ cursor: 'pointer' }}
                    onClick={handleMenuClick}
                />
                <StyledMenu
                    id={`connector-edit-${el.id}`}
                    anchorEl={anchorMenu}
                    keepMounted
                    open={Boolean(anchorMenu)}
                    onClose={handleMenuClose}
                >
                    {subMenu}
                </StyledMenu>
            </div>
        );
    }

    // Endpoint handles
    let endpointHandles = null;
    if (isSelected && isSelectable) {
        let p1Screen = drawUtils.reverseScalePoint(startPoint, localX1, localY1);
        let p2Screen = drawUtils.reverseScalePoint(startPoint, localX2, localY2);
        if (!p1Screen) p1Screen = drawUtils.reverseScalePoint(startPoint, localX1, localY1, email);
        if (!p2Screen) p2Screen = drawUtils.reverseScalePoint(startPoint, localX2, localY2, email);
        if (p1Screen && p2Screen) {
            endpointHandles = (
                <>
                    <div
                        style={{
                            position: 'absolute',
                            left: p1Screen.x - screenPos.x - 8,
                            top: p1Screen.y - screenPos.y - 8,
                            width: 16,
                            height: 16,
                            borderRadius: '50%',
                            backgroundColor: '#08AAB4',
                            border: '2px solid white',
                            cursor: 'move',
                            zIndex: 10,
                            pointerEvents: 'auto',
                            touchAction: 'none',
                        }}
                        onPointerDown={(e) => handleEndpointDrag(1, e)}
                    />
                    <div
                        style={{
                            position: 'absolute',
                            left: p2Screen.x - screenPos.x - 8,
                            top: p2Screen.y - screenPos.y - 8,
                            width: 16,
                            height: 16,
                            borderRadius: '50%',
                            backgroundColor: '#08AAB4',
                            border: '2px solid white',
                            cursor: 'move',
                            zIndex: 10,
                            pointerEvents: 'auto',
                            touchAction: 'none',
                        }}
                        onPointerDown={(e) => handleEndpointDrag(2, e)}
                    />
                </>
            );
        }
    }

    const containerStyle = {
        position: 'absolute',
        left: screenPos.x,
        top: screenPos.y,
        width: screenW,
        height: screenH,
        zIndex: isSelectable ? 0 : -1000,
        pointerEvents: 'none',
    };

    return (
        <div style={containerStyle} key={`connector-${el.id}`}>
            <svg
                width={screenW}
                height={screenH}
                viewBox={`0 0 ${boxW} ${boxH}`}
                style={{ overflow: 'visible', touchAction: isSelectable ? 'none' : 'auto' }}
            >
                {(() => {
                    const adx = svgX2 - svgX1;
                    const ady = svgY2 - svgY1;
                    const alen = Math.sqrt(adx * adx + ady * ady);
                    const arrowLen = Math.max(weight * 4, 10);
                    const ux = alen > 0 ? adx / alen : 0;
                    const uy = alen > 0 ? ady / alen : 0;
                    // Shorten line so it stops at arrow base (only for filled arrows)
                    const inset = isFilledArrow ? arrowLen : 0;
                    const lx1 = hasStartArrow ? svgX1 + ux * inset : svgX1;
                    const ly1 = hasStartArrow ? svgY1 + uy * inset : svgY1;
                    const lx2 = hasEndArrow ? svgX2 - ux * inset : svgX2;
                    const ly2 = hasEndArrow ? svgY2 - uy * inset : svgY2;
                    const angle = Math.atan2(ady, adx);
                    const arrowElements = [];
                    if (hasEndArrow) {
                        const tx = svgX2, ty = svgY2;
                        const a1x = tx - arrowLen * Math.cos(angle - Math.PI / 6);
                        const a1y = ty - arrowLen * Math.sin(angle - Math.PI / 6);
                        const a2x = tx - arrowLen * Math.cos(angle + Math.PI / 6);
                        const a2y = ty - arrowLen * Math.sin(angle + Math.PI / 6);
                        if (isFilledArrow) {
                            arrowElements.push(<polygon key='ae' points={`${tx},${ty} ${a1x},${a1y} ${a2x},${a2y}`}
                                                        fill={color} />);
                        } else {
                            arrowElements.push(<polyline key='ae' points={`${a1x},${a1y} ${tx},${ty} ${a2x},${a2y}`}
                                                         fill='none' stroke={color} strokeWidth={weight}
                                                         strokeLinecap='round' strokeLinejoin='round' />);
                        }
                    }
                    if (hasStartArrow) {
                        const tx = svgX1, ty = svgY1;
                        const ra = angle + Math.PI;
                        const a1x = tx - arrowLen * Math.cos(ra - Math.PI / 6);
                        const a1y = ty - arrowLen * Math.sin(ra - Math.PI / 6);
                        const a2x = tx - arrowLen * Math.cos(ra + Math.PI / 6);
                        const a2y = ty - arrowLen * Math.sin(ra + Math.PI / 6);
                        if (isFilledArrow) {
                            arrowElements.push(<polygon key='as' points={`${tx},${ty} ${a1x},${a1y} ${a2x},${a2y}`}
                                                        fill={color} />);
                        } else {
                            arrowElements.push(<polyline key='as' points={`${a1x},${a1y} ${tx},${ty} ${a2x},${a2y}`}
                                                         fill='none' stroke={color} strokeWidth={weight}
                                                         strokeLinecap='round' strokeLinejoin='round' />);
                        }
                    }
                    return (
                        <>
                            {/* Invisible wide line for hit detection */}
                            <line
                                x1={svgX1} y1={svgY1} x2={svgX2} y2={svgY2}
                                stroke='transparent'
                                strokeWidth={Math.max(weight * 3, 15)}
                                style={{ pointerEvents: 'stroke', cursor: isSelectable ? 'move' : 'default' }}
                                onPointerDown={handleLinePointerDown}
                            />
                            {/* Visible line shortened to arrow bases */}
                            <line
                                x1={lx1} y1={ly1} x2={lx2} y2={ly2}
                                stroke={color}
                                strokeWidth={weight}
                                strokeDasharray={dashArray}
                                strokeLinecap='round'
                                style={{ pointerEvents: 'none' }}
                            />
                            {arrowElements}
                        </>
                    );
                })()}
            </svg>
            {endpointHandles}
            {menuContent}
        </div>
    );
};

const StickyElements = React.forwardRef((props, ref) => {
    let [stickyComponents, setStickyComponents] = useState([]);
    let [fixedStickyComponents, setFixedStickyComponents] = useState([]);
    let [startPoint, setStartPoint] = useState({ x: 0, y: 0 });
    let [dialogClear, setDialogClear] = useState(null);
    let [isSelectable, setIsSelectable] = useState(false);
    let [isTextSelectable, setIsTextSelectable] = useState(false);
    let [lineage, setLineage] = useState(LINEAGE_NONE);
    let [fixedWritingUrl, setFixedWritingUrl] = useState(null);
    let [geometryElements, setGeometryElements] = useState([]);
    let [localSelectedItem, setLocalSelectedItem] = useState(null);
    let [selectedItemCoordinates, setSelectedItemCoordinates] = useState(null);
    let [selectedResizeItemCoordinates, setSelectedResizeItemCoordinates] = useState(null);

    const handleClose = () => {
        setDialogClear(null);
    };

    const removeItem = () => {
        props.removeStickyElement(dialogClear);
        setDialogClear(null);
    };

    const lineageData = useRef({});
    const pointerData = useRef({ cleanerCallback: null, canvasRef: React.createRef() });
    const auxDrawingData = useRef({ auxDrawingDataCanvasRef: React.createRef() });

    const updateLatexCallback = (id, latex) => {
        if (props.updateLatexElement) {
            props.updateLatexElement(id, latex);
        }
    };

    const updateFunctionGraphCallback = (id, expression, xMin, xMax, yMin, yMax, azimuth, elevation, color) => {
        if (props.updateFunctionGraphElement) {
            props.updateFunctionGraphElement(id, expression, xMin, xMax, yMin, yMax, azimuth, elevation, color);
        }
    };

    const selectSVGObject = (id, x, y, x1, y1) => {
        setLocalSelectedItem(id);
        let idx = stickyComponents.findIndex((ee) => ee.id === localSelectedItem);
        if (idx < 0) {
            setLocalSelectedItem(null);
            setSelectedItemCoordinates(null);
            setSelectedResizeItemCoordinates(null);
        } else {
            if (stickyComponents[idx].stickyType !== STICKY_ELEMENTS_TYPE.SVG) {
                setSelectedItemCoordinates(null);
                setSelectedResizeItemCoordinates(null);
            } else {
                setSelectedItemCoordinates({ x: x, y: y });
                setSelectedResizeItemCoordinates({ x: x1, y: y1 });
            }
        }

    };

    useImperativeHandle(ref, () => ({
        addStickyElement(el) {
            setStickyComponents([...stickyComponents, el]);
        }, shallowSyncPageElements(elements) {
            if (!elements) {
                setStickyComponents([]);
                setLocalSelectedItem(null);
                setSelectedItemCoordinates(null);
                setSelectedResizeItemCoordinates(null);
            } else {
                setStickyComponents([...elements]);
                if (localSelectedItem) {
                    let idx = elements.findIndex((ee) => ee.id === localSelectedItem);
                    if (idx < 0) {
                        setLocalSelectedItem(null);
                        setSelectedItemCoordinates(null);
                        setSelectedResizeItemCoordinates(null);
                    } else {
                        if (elements[idx].stickyType !== STICKY_ELEMENTS_TYPE.SVG) {
                            setSelectedItemCoordinates(null);
                            setSelectedResizeItemCoordinates(null);
                        }
                    }
                }

            }
        }, setFixedStickyElements(elements) {
            if (elements) {
                setFixedStickyComponents([...elements]);
            } else {
                setFixedStickyComponents([]);
            }
        }, setFixedWritingUrl(url) {
            // console.log('=== setting fixed writing', url);
            setFixedWritingUrl(url);
        }, updateStartPoint(newStartPoint) {
            setStartPoint(newStartPoint);
        }, setSelectable(value) {
            setIsSelectable(value);
            if (!value) {
                setLocalSelectedItem(null);
                setSelectedItemCoordinates(null);
                setSelectedResizeItemCoordinates(null);
            }
        }, setIsTextSelectable(value) {
            setIsTextSelectable(value);
        }, setLineage(lineage) {
            // console.log('=== setting lineage', lineage);
            // console.trace();
            if (lineage !== LINEAGE_NONE && !lineageData.current[lineage]) {
                lineageData.current[lineage] = drawUtils.buildLineageImage(lineage);
            }
            setLineage(lineage);
        }, drawPointerEvent() {
            if (pointerData.current) {
                if (pointerData.current.cleanerCallback) {
                    clearTimeout(pointerData.current.cleanerCallback);
                }
                pointerData.current.cleanerCallback = setTimeout(() => {
                    if (pointerData.current && pointerData.current.canvasRef && pointerData.current.canvasRef.current) {
                        pointerData.current.cleanerCallback = null;
                        pointerData.current.canvasRef.current
                            .getContext('2d')
                            .clearRect(0, 0, drawUtils.CANVAS_ACTUAL_WIDTH, drawUtils.CANVAS_ACTUAL_HEIGHT);
                    }
                }, 2000);
            }
        }, drawShape(tool, x1, y1, x2, y2, weight, color) {
            if (auxDrawingData.current) {
                if (auxDrawingData.current && auxDrawingData.current.auxDrawingDataCanvasRef && auxDrawingData.current.auxDrawingDataCanvasRef.current) {
                    let ctx = auxDrawingData.current.auxDrawingDataCanvasRef.current.getContext('2d');
                    ctx.clearRect(0, 0, drawUtils.CANVAS_ACTUAL_WIDTH, drawUtils.CANVAS_ACTUAL_HEIGHT);
                    if (!tool) {
                        return;
                    }
                    if (x1 === x2 && y1 === y2) return;
                    let width = drawUtils.computeLineWidth(weight);
                    ctx.lineWidth = width;
                    ctx.strokeStyle = color;

                    if (tool === TOOL_LINE || tool === TOOL_PEN) {
                        ctx.lineCap = 'round';
                        ctx.lineJoin = 'round';
                        ctx.beginPath();
                        ctx.moveTo(x1, y1);
                        ctx.lineTo(x2, y2);
                        ctx.stroke();
                        ctx.closePath();
                    } else if (tool === TOOL_RECTANGLE) {
                        ctx.beginPath();
                        ctx.lineCap = 'square';
                        ctx.lineJoin = 'miter';
                        ctx.miterLimit = 10;
                        ctx.lineWidth = width;
                        ctx.rect(x1 > x2 ? x2 : x1, y1 > y2 ? y2 : y1, Math.abs(x2 - x1), Math.abs(y2 - y1));
                        ctx.stroke();
                        ctx.closePath();
                    } else if (tool === TOOL_CIRCLE) {
                        ctx.beginPath();
                        ctx.lineCap = 'square';
                        ctx.lineJoin = 'miter';
                        ctx.miterLimit = 10;
                        ctx.ellipse(Math.min(x1, x2) + Math.abs((x1 - x2) / 2), Math.min(y1, y2) + Math.abs((y1 - y2) / 2), Math.abs((x2 - x1) / 2), Math.abs((y2 - y1) / 2), 0, 0, 360);
                        ctx.stroke();
                        ctx.closePath();
                    }
                }
            }
        }, drawArc(x, y, archWidth, direction, start, end, weight, color) {
            if (auxDrawingData.current) {
                if (auxDrawingData.current && auxDrawingData.current.auxDrawingDataCanvasRef && auxDrawingData.current.auxDrawingDataCanvasRef.current) {
                    let ctx = auxDrawingData.current.auxDrawingDataCanvasRef.current.getContext('2d');
                    ctx.clearRect(0, 0, drawUtils.CANVAS_ACTUAL_WIDTH, drawUtils.CANVAS_ACTUAL_HEIGHT);
                    ctx.lineWidth = drawUtils.computeLineWidth(weight);
                    ctx.strokeStyle = color;
                    ctx.beginPath();
                    if (start === end) {
                        ctx.arc(x, y, archWidth, 0, 2 * Math.PI, direction === -1);
                    } else {
                        ctx.arc(x, y, archWidth, (start * Math.PI) / 180, (end * Math.PI) / 180, direction === -1);
                    }
                    ctx.stroke();
                }
            }
        }, clearAuxDrawing() {
            if (auxDrawingData.current) {
                if (auxDrawingData.current && auxDrawingData.current.auxDrawingDataCanvasRef && auxDrawingData.current.auxDrawingDataCanvasRef.current) {
                    let ctx = auxDrawingData.current.auxDrawingDataCanvasRef.current.getContext('2d');
                    ctx.clearRect(0, 0, drawUtils.CANVAS_ACTUAL_WIDTH, drawUtils.CANVAS_ACTUAL_HEIGHT);
                    ctx.beginPath();
                    ctx.stroke();
                }
            }
        }, getPointerContext() {
            if (pointerData.current && pointerData.current.canvasRef && pointerData.current.canvasRef.current) {
                return pointerData.current.canvasRef.current.getContext('2d');
            }
            return null;
        }, updateGeometryState(geometry) {
            let geometryEls = [];
            if (geometry.compass && geometry.compass.visible) {
                let ell = document.getElementById('compass-move-icon-position')?.getBoundingClientRect();
                let elSP = document.getElementById('compass-start-point')?.getBoundingClientRect();
                if (!ell || !elSP) {
                    return;
                }
                let adjY = elSP.top - ell.top;
                let adjX = elSP.left - ell.left;
                geometryEls.push(<DraggerControl
                    startPoint={startPoint}
                    el={{ id: 'mainCompassMover' }}
                    point={geometry.compass.position}
                    key={`stickyEls-compass-main-move`}
                    cursor={'move'}
                    // adjustLeft={-16}
                    adjustLeft={-1 * adjX}
                    // adjustTop={-32}
                    adjustTop={-1 * adjY}
                    icon={<div
                        id='compass-move-icon-position-drag'
                        style={{
                            position: 'absolute', width: '100%', height: '100%',
                        }}
                    />}
                    onDrag={window.compassMove}
                    onStart={window.compassStartMove}
                    onStop={window.compassStopMove}
                />);
                let el = document.getElementById('compass-expand-icon-position')?.getBoundingClientRect();
                let reverseScaledPoint = drawUtils.scalePoint(startPoint, el.x, el.y);
                geometryEls.push(<DraggerControl
                    startPoint={startPoint}
                    el={{ id: 'mainCompassExpander' }}
                    point={{ x: reverseScaledPoint.x, y: reverseScaledPoint.y }}
                    key={`stickyEls-compass-main-expand`}
                    cursor={'move'}
                    adjustLeft={-32}
                    adjustTop={-48}
                    icon={<div
                        id='compass-expand-icon-position-drag'
                        style={{
                            position: 'absolute', width: '100%', height: '100%',
                        }}
                    />}
                    onDrag={window.expandCompass}
                    onStart={window.handleStartCompassExpand}
                    onStop={window.stopCompassExpand}
                />);
                el = document.getElementById('compass-rotate-icon-position')?.getBoundingClientRect();
                reverseScaledPoint = drawUtils.scalePoint(startPoint, el.x, el.y);
                geometryEls.push(<DraggerControl
                    startPoint={startPoint}
                    el={{ id: 'mainCompassRotator' }}
                    point={{ x: reverseScaledPoint.x, y: reverseScaledPoint.y }}
                    key={`stickyEls-compass-main-rotate`}
                    cursor={'move'}
                    adjustLeft={-32}
                    adjustTop={-48}
                    icon={<div
                        id='compass-rotate-icon-position-drag'
                        style={{
                            position: 'absolute', width: '100%', height: '100%',
                        }}
                    />}
                    onDrag={window.rotateCompass}
                    onStart={window.handleStartCompassRotate}
                    onStop={window.stopCompassRotate}
                />);
                let deleteEl = document.getElementById('compass-delete-icon-position').getBoundingClientRect();
                let rect = drawUtils.getCurrentCanvasRect();

                geometryEls.push(<div
                    color={'secondary'}
                    key={'main-compass-delete-div'}
                    onClick={(e) => {
                        if (window.hideCompass) {
                            window.hideCompass();
                        }
                        e.stopPropagation();
                    }}
                    onTouchStart={(e) => {
                        if (window.hideCompass) {
                            window.hideCompass();
                        }
                        e.stopPropagation();
                    }}
                    style={{
                        top: deleteEl.top - rect.top + 'px',
                        left: deleteEl.left - rect.left + 'px',
                        width: '32px',
                        height: '32px',
                        position: 'absolute',
                        cursor: 'auto',
                    }}
                />);
            }

            if (geometry.ruler && geometry.ruler.visible) {
                let ell = document.getElementById('ruler-move-icon-position')?.getBoundingClientRect();
                let elSP = document.getElementById('ruler-start-point')?.getBoundingClientRect();
                if (!ell || !elSP) return;
                let adjY = elSP.top - ell.top;
                let adjX = elSP.left - ell.left;
                geometryEls.push(<DraggerControl
                    startPoint={startPoint}
                    el={{ id: 'mainRulerMover' }}
                    point={geometry.ruler.position}
                    key={`stickyEls-ruler-main-move`}
                    // adjustLeft={-16}
                    adjustLeft={-1 * adjX}
                    cursor={'move'}
                    // adjustTop={-32}
                    adjustTop={-1 * adjY}
                    icon={<div
                        id='ruler-move-icon-position-drag'
                        style={{
                            position: 'absolute', width: '100%', height: '100%',
                        }}
                    />}
                    onDrag={window.moveRuler}
                    onStart={window.handleStartRulerMove}
                    onStop={window.stopRuler}
                />);

                let el = document.getElementById('ruler-rotate-icon-position')?.getBoundingClientRect();
                let reverseScaledPoint = drawUtils.scalePoint(startPoint, el.x, el.y);
                geometryEls.push(<DraggerControl
                    startPoint={startPoint}
                    el={{ id: 'mainRulerRotator' }}
                    point={{ x: reverseScaledPoint.x, y: reverseScaledPoint.y }}
                    key={`stickyEls-ruler-main-rotate`}
                    adjustLeft={-32}
                    adjustTop={-48}
                    cursor={'move'}
                    icon={<div
                        id='compass-rotate-icon-position-drag'
                        style={{
                            position: 'absolute', width: '100%', height: '100%',
                        }}
                    />}
                    onDrag={window.rotateRuler}
                    onStart={window.handleStartRulerRotate}
                    onStop={window.stopRulerRotate}
                />);
                let deleteEl = document.getElementById('ruler-delete-icon-position').getBoundingClientRect();
                let rect = drawUtils.getCurrentCanvasRect();

                geometryEls.push(<div
                    color={'secondary'}
                    key={'main-ruler-delete-div'}
                    onClick={(e) => {
                        if (window.hideRuler) {
                            window.hideRuler();
                        }
                        e.stopPropagation();
                    }}
                    onTouchStart={(e) => {
                        if (window.hideRuler) {
                            window.hideRuler();
                        }
                        e.stopPropagation();
                    }}
                    style={{
                        top: deleteEl.top - rect.top + 'px',
                        left: deleteEl.left - rect.left + 'px',
                        width: '32px',
                        height: '32px',
                        position: 'absolute',
                        cursor: 'auto',
                    }}
                />);
            }

            if (geometry.protractor && geometry.protractor.visible) {
                let ell = document.getElementById('protractor-move-icon-position')?.getBoundingClientRect();
                if (!ell) return;
                let reverseScaledPoint = drawUtils.scalePoint(startPoint, ell.x, ell.y);
                geometryEls.push(<DraggerControl
                    startPoint={startPoint}
                    el={{ id: 'mainProtractorMover' }}
                    point={{ x: reverseScaledPoint.x, y: reverseScaledPoint.y }}
                    key={`stickyEls-protractor-main-move`}
                    adjustLeft={-32}
                    adjustTop={-48}
                    cursor={'move'}
                    icon={<div
                        id='protractor-move-icon-position-drag'
                        style={{
                            position: 'absolute', width: '100%', height: '100%',
                        }}
                    />}
                    onDrag={window.moveProtractor}
                    onStart={window.handleStartMoveProtractor}
                    onStop={window.stopProtractor}
                />);

                let el = document.getElementById('protractor-rotate-icon-position')?.getBoundingClientRect();
                reverseScaledPoint = drawUtils.scalePoint(startPoint, el.x, el.y);
                geometryEls.push(<DraggerControl
                    startPoint={startPoint}
                    el={{ id: 'mainProtractorRotator' }}
                    point={{ x: reverseScaledPoint.x, y: reverseScaledPoint.y }}
                    key={`stickyEls-protractor-main-rotate`}
                    adjustLeft={-32}
                    adjustTop={-48}
                    cursor={'move'}
                    icon={<div
                        id='compass-protractor-icon-position-drag'
                        style={{
                            position: 'absolute', width: '100%', height: '100%',
                        }}
                    />}
                    onDrag={window.rotateProtractor}
                    onStart={window.handleStartRotateProtractor}
                    onStop={window.stopProtractorRotate}
                />);
                let deleteEl = document.getElementById('protractor-delete-icon-position').getBoundingClientRect();
                let rect = drawUtils.getCurrentCanvasRect();

                geometryEls.push(<div
                    color={'secondary'}
                    key={'main-protractor-delete-div'}
                    onClick={(e) => {
                        if (window.hideProtractor) {
                            window.hideProtractor();
                        }
                        e.stopPropagation();
                    }}
                    onTouchStart={(e) => {
                        if (window.hideProtractor) {
                            window.hideProtractor();
                        }
                        e.stopPropagation();
                    }}
                    style={{
                        top: deleteEl.top - rect.top + 'px',
                        left: deleteEl.left - rect.left + 'px',
                        width: '32px',
                        height: '32px',
                        position: 'absolute',
                        cursor: 'auto',
                    }}
                />);
            }

            if (geometry.trySquare && geometry.trySquare.visible) {
                let ell = document.getElementById('trysquare-move-icon-position')?.getBoundingClientRect();
                let elOrigin = document.getElementById('trysquare-origin-point')?.getBoundingClientRect();
                if (!ell || !elOrigin) return;
                let adjX = elOrigin.left - ell.left;
                let adjY = elOrigin.top - ell.top;
                // point uses origin (bottom-left) coordinates so reverseScale lands at the pivot
                let originPoint = {
                    x: geometry.trySquare.position.x,
                    y: geometry.trySquare.position.y + 250,
                };
                geometryEls.push(<DraggerControl
                    startPoint={startPoint}
                    el={{ id: 'mainTrySquareMover' }}
                    point={originPoint}
                    key={`stickyEls-trysquare-main-move`}
                    adjustLeft={-1 * adjX}
                    cursor={'move'}
                    adjustTop={-1 * adjY}
                    icon={<div
                        id='trysquare-move-icon-position-drag'
                        style={{
                            position: 'absolute', width: '100%', height: '100%',
                        }}
                    />}
                    onDrag={window.moveTrySquare}
                    onStart={window.handleStartTrySquareMove}
                    onStop={window.stopTrySquare}
                />);

                let el = document.getElementById('trysquare-rotate-icon-position')?.getBoundingClientRect();
                let reverseScaledPoint = drawUtils.scalePoint(startPoint, el.x, el.y);
                geometryEls.push(<DraggerControl
                    startPoint={startPoint}
                    el={{ id: 'mainTrySquareRotator' }}
                    point={{ x: reverseScaledPoint.x, y: reverseScaledPoint.y }}
                    key={`stickyEls-trysquare-main-rotate`}
                    adjustLeft={-32}
                    adjustTop={-48}
                    cursor={'move'}
                    icon={<div
                        id='trysquare-rotate-icon-position-drag'
                        style={{
                            position: 'absolute', width: '100%', height: '100%',
                        }}
                    />}
                    onDrag={window.rotateTrySquare}
                    onStart={window.handleStartTrySquareRotate}
                    onStop={window.stopTrySquareRotate}
                />);
                let deleteEl = document.getElementById('trysquare-delete-icon-position').getBoundingClientRect();
                let rect = drawUtils.getCurrentCanvasRect();

                geometryEls.push(<div
                    color={'secondary'}
                    key={'main-trysquare-delete-div'}
                    onClick={(e) => {
                        if (window.hideTrySquare) {
                            window.hideTrySquare();
                        }
                        e.stopPropagation();
                    }}
                    onTouchStart={(e) => {
                        if (window.hideTrySquare) {
                            window.hideTrySquare();
                        }
                        e.stopPropagation();
                    }}
                    style={{
                        top: deleteEl.top - rect.top + 'px',
                        left: deleteEl.left - rect.left + 'px',
                        width: '32px',
                        height: '32px',
                        position: 'absolute',
                        cursor: 'auto',
                    }}
                />);
            }

            geometryEls.filter((g) => !g);
            setGeometryElements(geometryEls);
        },
    }));

    let fixedImageItems = fixedStickyComponents.map((el) => {
        if (el.stickyType === 'image' || el.stickyType === 'svg') {
            let reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y);
            let reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, el.x + el.width, el.y + el.height);

            if (!reverseScaledPoint) {
                reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y, props.email);
            }
            if (!reverseScaledWHPoints) {
                reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, el.x + el.width, el.y + el.height, props.email);
            }
            if (!reverseScaledPoint || !reverseScaledWHPoints) {
                // console.log('==== unable to see ', props.email);
                return null;
            }

            return (<StickyImage
                key={'stickyImageItems-' + el.id}
                reverseScaledPoint={reverseScaledPoint}
                reverseScaledWHPoints={reverseScaledWHPoints}
                el={el}
                isSelectable={false}
                setDialogClear={setDialogClear}
                startPoint={startPoint}
            />);
        }
        return null;
    });

    let fixedLatexItems = fixedStickyComponents.map((el) => {
        if (el.stickyType === 'latex') {
            let reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y);
            let reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, el.x + el.width, el.y + el.height);

            if (!reverseScaledPoint) {
                reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y, props.email);
            }
            if (!reverseScaledWHPoints) {
                reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, el.x + el.width, el.y + el.height, props.email);
            }
            if (!reverseScaledPoint || !reverseScaledWHPoints) {
                // console.log('==== unable to see ', props.email);
                return null;
            }

            return (<StickyLatex
                key={'stickyLatexItems-' + el.id}
                reverseScaledPoint={reverseScaledPoint}
                reverseScaledWHPoints={reverseScaledWHPoints}
                el={el}
                isSelectable={false}
                setDialogClear={setDialogClear}
                startPoint={startPoint}
                updateLatexCallback={updateLatexCallback}
            />);
        }
        return null;
    });

    let latexItems = stickyComponents.map((el) => {
        if (el.stickyType === 'latex') {
            let reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y);
            let reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, el.x + el.width, el.y + el.height);

            if (!reverseScaledPoint) {
                reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y, props.email);
            }
            if (!reverseScaledWHPoints) {
                reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, el.x + el.width, el.y + el.height, props.email);
            }
            if (!reverseScaledPoint || !reverseScaledWHPoints) {
                // console.log('==== unable to see ', props.email);
                return null;
            }

            return (<StickyLatex
                key={'latexItems-' + el.id}
                reverseScaledPoint={reverseScaledPoint}
                reverseScaledWHPoints={reverseScaledWHPoints}
                el={el}
                setDialogClear={setDialogClear}
                startPoint={startPoint}
                isSelectable={(isSelectable && boardManager.lessonState.boardType === BOARD_TYPE.MULTI_BOARD) || (isSelectable && boardManager.isAdmin) || (isSelectable && boardManager.adminEmail !== el.creator)}
                updateStickyImagePosition={props.updateStickyImagePosition}
                updateLatexCallback={updateLatexCallback}
                localSelectedItem={localSelectedItem}
                setLocalSelectedItem={setLocalSelectedItem}
            />);
        }
        return null;
    });

    let embeddedSvgItems = stickyComponents.map((el) => {
        if (el.stickyType === 'embeddedSvg') {
            let reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y);
            let reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, el.x + el.width, el.y + el.height);

            if (!reverseScaledPoint) {
                reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y, props.email);
            }
            if (!reverseScaledWHPoints) {
                reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, el.x + el.width, el.y + el.height, props.email);
            }
            if (!reverseScaledPoint || !reverseScaledWHPoints) {
                return null;
            }

            return (<StickyEmbeddedSvg
                key={'embeddedSvgItems-' + el.id}
                reverseScaledPoint={reverseScaledPoint}
                reverseScaledWHPoints={reverseScaledWHPoints}
                el={el}
                setDialogClear={setDialogClear}
                startPoint={startPoint}
                isSelectable={(isSelectable && boardManager.lessonState.boardType === BOARD_TYPE.MULTI_BOARD) || (isSelectable && boardManager.isAdmin) || (isSelectable && boardManager.adminEmail !== el.creator)}
                updateStickyImagePosition={props.updateStickyImagePosition}
                localSelectedItem={localSelectedItem}
                setLocalSelectedItem={setLocalSelectedItem}
            />);
        }
        return null;
    });

    let functionGraphItems = stickyComponents.map((el) => {
        if (el.stickyType === 'functionGraph') {
            let reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y);
            let reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, el.x + el.width, el.y + el.height);

            if (!reverseScaledPoint) {
                reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y, props.email);
            }
            if (!reverseScaledWHPoints) {
                reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, el.x + el.width, el.y + el.height, props.email);
            }
            if (!reverseScaledPoint || !reverseScaledWHPoints) {
                return null;
            }

            return (<StickyFunctionGraph
                key={'functionGraphItems-' + el.id}
                reverseScaledPoint={reverseScaledPoint}
                reverseScaledWHPoints={reverseScaledWHPoints}
                el={el}
                setDialogClear={setDialogClear}
                startPoint={startPoint}
                isSelectable={(isSelectable && boardManager.lessonState.boardType === BOARD_TYPE.MULTI_BOARD) || (isSelectable && boardManager.isAdmin) || (isSelectable && boardManager.adminEmail !== el.creator)}
                updateStickyImagePosition={props.updateStickyImagePosition}
                updateFunctionGraphCallback={updateFunctionGraphCallback}
                localSelectedItem={localSelectedItem}
                setLocalSelectedItem={setLocalSelectedItem}
            />);
        }
        return null;
    });

    let imageItems = stickyComponents.map((el) => {
        if (el.stickyType === 'image' || el.stickyType === 'svg') {
            let reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y);
            let reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, el.x + el.width, el.y + el.height);

            if (!reverseScaledPoint) {
                reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y, props.email);
            }
            if (!reverseScaledWHPoints) {
                reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, el.x + el.width, el.y + el.height, props.email);
            }
            if (!reverseScaledPoint || !reverseScaledWHPoints) {
                // console.log('==== unable to see ', props.email);
                return null;
            }

            return (<StickyImage
                key={'stickyImageItems-' + el.id}
                reverseScaledPoint={reverseScaledPoint}
                reverseScaledWHPoints={reverseScaledWHPoints}
                el={el}
                isSelectable={(isSelectable && boardManager.lessonState.boardType === BOARD_TYPE.MULTI_BOARD) || (isSelectable && boardManager.isAdmin) || (isSelectable && boardManager.adminEmail !== el.creator)}
                setDialogClear={setDialogClear}
                updateStickyImagePosition={props.updateStickyImagePosition}
                startPoint={startPoint}
                localSelectedItem={localSelectedItem}
                setLocalSelectedItem={selectSVGObject}
            />);
        }
        return null;
    });

    let fixedEmbeddedSvgItems = fixedStickyComponents.map((el) => {
        if (el.stickyType === 'embeddedSvg') {
            let reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y);
            let reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, el.x + el.width, el.y + el.height);

            if (!reverseScaledPoint) {
                reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y, props.email);
            }
            if (!reverseScaledWHPoints) {
                reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, el.x + el.width, el.y + el.height, props.email);
            }
            if (!reverseScaledPoint || !reverseScaledWHPoints) {
                return null;
            }

            return (<StickyEmbeddedSvg
                key={'fixedEmbeddedSvgItems-' + el.id}
                reverseScaledPoint={reverseScaledPoint}
                reverseScaledWHPoints={reverseScaledWHPoints}
                el={el}
                setDialogClear={setDialogClear}
                startPoint={startPoint}
                isSelectable={false}
                updateStickyImagePosition={props.updateStickyImagePosition}
                localSelectedItem={localSelectedItem}
                setLocalSelectedItem={setLocalSelectedItem}
            />);
        }
        return null;
    });

    let fixedFunctionGraphItems = fixedStickyComponents.map((el) => {
        if (el.stickyType === 'functionGraph') {
            let reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y);
            let reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, el.x + el.width, el.y + el.height);

            if (!reverseScaledPoint) {
                reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y, props.email);
            }
            if (!reverseScaledWHPoints) {
                reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, el.x + el.width, el.y + el.height, props.email);
            }
            if (!reverseScaledPoint || !reverseScaledWHPoints) {
                return null;
            }

            return (<StickyFunctionGraph
                key={'fixedFunctionGraphItems-' + el.id}
                reverseScaledPoint={reverseScaledPoint}
                reverseScaledWHPoints={reverseScaledWHPoints}
                el={el}
                setDialogClear={setDialogClear}
                startPoint={startPoint}
                isSelectable={false}
                updateStickyImagePosition={props.updateStickyImagePosition}
                updateFunctionGraphCallback={updateFunctionGraphCallback}
                localSelectedItem={localSelectedItem}
                setLocalSelectedItem={setLocalSelectedItem}
            />);
        }
        return null;
    });

    let fixedTextItems = fixedStickyComponents.map((el) => {
        if (el.stickyType === 'text') {
            let reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y);
            let reverseScaledWHPoints = drawUtils.reverseScalePoint({ x: 0, y: 0 }, el.width, el.height);

            if (!reverseScaledPoint) {
                reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y, props.email);
            }
            if (!reverseScaledWHPoints) {
                reverseScaledWHPoints = drawUtils.reverseScalePoint({ x: 0, y: 0 }, el.width, el.height, props.email);
            }
            if (!reverseScaledPoint || !reverseScaledWHPoints) {
                // console.log('==== unable to see ', props.email);
                return null;
            }

            return (<TextBoxForSticky
                key={'stickyTextItems-' + el.id}
                id={el.id}
                x={reverseScaledPoint.x}
                y={reverseScaledPoint.y}
                width={reverseScaledWHPoints.x}
                height={reverseScaledWHPoints.y}
                text={el.text}
                weight={el.weight}
                color={el.color}
                fontSize={el.fontSize}
                fontFamily={el.fontFamily}
                fontStyle={el.fontStyle}
                fontWeight={el.fontWeight}
                textDecoration={el.textDecoration}
                isSelectable={false}
                startPoint={startPoint}
                setDialogClear={setDialogClear}
                email={props.email}
                setWriting={props.setWriting}
                removeElement={props.removeStickyElement}
            />);
        }
        return null;
    });

    let textItems = stickyComponents.map((el) => {
        if (el.stickyType === 'text') {
            let reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y);

            let reverseScaledWHPoints = drawUtils.reverseScalePoint({ x: 0, y: 0 }, el.width, el.height);

            if (!reverseScaledPoint) {
                reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y, props.email);
            }
            if (!reverseScaledWHPoints) {
                reverseScaledWHPoints = drawUtils.reverseScalePoint({ x: 0, y: 0 }, el.width, el.height, props.email);
            }

            if (!reverseScaledPoint || !reverseScaledWHPoints) {
                // console.log('==== unable to see ', props.email);
                return null;
            }

            return (<TextBoxForSticky
                key={'stickyTextItems-' + el.id}
                id={el.id}
                x={reverseScaledPoint.x}
                y={reverseScaledPoint.y}
                width={reverseScaledWHPoints.x}
                height={reverseScaledWHPoints.y}
                text={el.text}
                weight={el.weight}
                color={el.color}
                fontSize={el.fontSize}
                fontFamily={el.fontFamily}
                fontStyle={el.fontStyle}
                fontWeight={el.fontWeight}
                textDecoration={el.textDecoration}
                isSelectable={((isSelectable || isTextSelectable) && boardManager.lessonState.boardType === BOARD_TYPE.MULTI_BOARD) || ((isSelectable || isTextSelectable) && boardManager.isAdmin) || ((isSelectable || isTextSelectable) && boardManager.adminEmail !== el.creator)}
                updateStickyTextInfo={props.updateStickyTextInfo}
                startPoint={startPoint}
                setDialogClear={setDialogClear}
                email={props.email}
                setWriting={props.setWriting}
                removeElement={props.removeStickyElement}
                localSelectedItem={localSelectedItem}
                setLocalSelectedItem={setLocalSelectedItem}
            />);
        }
        return null;
    });

    let connectorItems = stickyComponents.map((el) => {
        if (el.stickyType === STICKY_ELEMENTS_TYPE.CONNECTOR) {
            return (
                <StickyConnector
                    key={'connectorItem-' + el.id}
                    el={el}
                    isSelectable={(isSelectable && boardManager.lessonState.boardType === BOARD_TYPE.MULTI_BOARD) || (isSelectable && boardManager.isAdmin) || (isSelectable && boardManager.adminEmail !== el.creator)}
                    setDialogClear={setDialogClear}
                    updateConnectorPosition={boardManager.updateLocalConnectorPosition}
                    startPoint={startPoint}
                    localSelectedItem={localSelectedItem}
                    setLocalSelectedItem={setLocalSelectedItem}
                    email={props.email}
                />
            );
        }
        return null;
    });

    let fixedConnectorItems = fixedStickyComponents.map((el) => {
        if (el.stickyType === STICKY_ELEMENTS_TYPE.CONNECTOR) {
            return (
                <StickyConnector
                    key={'fixedConnectorItem-' + el.id}
                    el={el}
                    isSelectable={false}
                    setDialogClear={setDialogClear}
                    updateConnectorPosition={boardManager.updateLocalConnectorPosition}
                    startPoint={startPoint}
                    localSelectedItem={localSelectedItem}
                    setLocalSelectedItem={setLocalSelectedItem}
                    email={props.email}
                />
            );
        }
        return null;
    });

    let fixedLinkItems = fixedStickyComponents.map((el) => {
        if (el.stickyType === 'link') {
            let reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y);
            let reverseScaledWHPoints = drawUtils.reverseScalePoint({ x: 0, y: 0 }, el.width, el.height);

            if (!reverseScaledPoint) {
                reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y, props.email);
            }
            if (!reverseScaledWHPoints) {
                reverseScaledWHPoints = drawUtils.reverseScalePoint({ x: 0, y: 0 }, el.width, el.height, props.email);
            }
            if (!reverseScaledPoint || !reverseScaledWHPoints) {
                return null;
            }

            return (<LinkBoxForSticky
                key={'stickyLinkItems-' + el.id}
                id={el.id}
                x={reverseScaledPoint.x}
                y={reverseScaledPoint.y}
                width={reverseScaledWHPoints.x}
                height={reverseScaledWHPoints.y}
                text={el.text}
                url={el.stickyURL}
                weight={el.weight}
                color={el.color}
                fontSize={el.fontSize}
                fontFamily={el.fontFamily}
                fontStyle={el.fontStyle}
                fontWeight={el.fontWeight}
                textDecoration={el.textDecoration}
                previewImage={el.previewImage}
                showPreview={el.showPreview !== false}
                isSelectable={false}
                startPoint={startPoint}
                setDialogClear={setDialogClear}
                email={props.email}
                removeElement={props.removeStickyElement}
            />);
        }
        return null;
    });

    let linkItems = stickyComponents.map((el) => {
        if (el.stickyType === 'link') {
            let reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y);
            let reverseScaledWHPoints = drawUtils.reverseScalePoint({ x: 0, y: 0 }, el.width, el.height);

            if (!reverseScaledPoint) {
                reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, el.x, el.y, props.email);
            }
            if (!reverseScaledWHPoints) {
                reverseScaledWHPoints = drawUtils.reverseScalePoint({ x: 0, y: 0 }, el.width, el.height, props.email);
            }

            if (!reverseScaledPoint || !reverseScaledWHPoints) {
                return null;
            }

            return (<LinkBoxForSticky
                key={'stickyLinkItems-' + el.id}
                id={el.id}
                x={reverseScaledPoint.x}
                y={reverseScaledPoint.y}
                width={reverseScaledWHPoints.x}
                height={reverseScaledWHPoints.y}
                text={el.text}
                url={el.stickyURL}
                weight={el.weight}
                color={el.color}
                fontSize={el.fontSize}
                fontFamily={el.fontFamily}
                fontStyle={el.fontStyle}
                fontWeight={el.fontWeight}
                textDecoration={el.textDecoration}
                previewImage={el.previewImage}
                showPreview={el.showPreview !== false}
                isSelectable={((isSelectable || isTextSelectable) && boardManager.lessonState.boardType === BOARD_TYPE.MULTI_BOARD) || ((isSelectable || isTextSelectable) && boardManager.isAdmin) || ((isSelectable || isTextSelectable) && boardManager.adminEmail !== el.creator)}
                updateStickyLinkInfo={props.updateStickyLinkInfo}
                startPoint={startPoint}
                setDialogClear={setDialogClear}
                email={props.email}
                removeElement={props.removeStickyElement}
                localSelectedItem={localSelectedItem}
                setLocalSelectedItem={setLocalSelectedItem}
            />);
        }
        return null;
    });

    let items = [...fixedImageItems, ...imageItems, ...fixedTextItems, ...textItems, ...fixedLinkItems, ...linkItems, ...fixedLatexItems, ...latexItems, ...fixedEmbeddedSvgItems, ...embeddedSvgItems, ...fixedFunctionGraphItems, ...functionGraphItems, ...fixedConnectorItems, ...connectorItems, ...geometryElements];

    let lineageElement;
    if (lineage !== LINEAGE_NONE && lineageData.current[lineage]) {
        let reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, 0, 0);
        let reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, drawUtils.CANVAS_ACTUAL_WIDTH, drawUtils.CANVAS_ACTUAL_HEIGHT);

        if (!reverseScaledPoint) {
            reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, 0, 0, props.email);
        }
        if (!reverseScaledWHPoints) {
            reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, drawUtils.CANVAS_ACTUAL_WIDTH, drawUtils.CANVAS_ACTUAL_HEIGHT, props.email);
        }
        if (!reverseScaledPoint || !reverseScaledWHPoints) {
            lineageElement = <div style={lineageStyle} />;
        } else {
            let myStyle = { ...imagePasteBoxInactive };
            myStyle.position = 'absolute';
            myStyle.top = reverseScaledPoint.y + 'px';
            myStyle.left = reverseScaledPoint.x + 'px';
            myStyle.width = reverseScaledWHPoints.x - reverseScaledPoint.x + 'px';
            myStyle.height = reverseScaledWHPoints.y - reverseScaledPoint.y + 'px';
            myStyle.backgroundColor = '#fff';
            myStyle.zIndex = '-1000';
            lineageElement = (<div style={myStyle} key={'lineage'}>
                <img src={lineageData.current[lineage]} alt='' style={imagePasteImg} />
            </div>);
        }
    } else {
        lineageElement = <div style={lineageStyle} />;
    }
    let fixedWriting = null;
    // console.log('=== got fixed writing', fixedWritingUrl);
    if (fixedWritingUrl) {
        let reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, 0, 0);
        let reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, drawUtils.CANVAS_ACTUAL_WIDTH, drawUtils.CANVAS_ACTUAL_HEIGHT);
        if (!reverseScaledPoint) {
            reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, 0, 0, props.email);
        }
        if (!reverseScaledWHPoints) {
            reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, drawUtils.CANVAS_ACTUAL_WIDTH, drawUtils.CANVAS_ACTUAL_HEIGHT, props.email);
        }
        if (!reverseScaledPoint || !reverseScaledWHPoints) {
            fixedWriting = null;
        } else {
            let myStyle = { ...imagePasteBoxInactive };
            myStyle.position = 'absolute';
            myStyle.top = reverseScaledPoint.y + 'px';
            myStyle.left = reverseScaledPoint.x + 'px';
            myStyle.width = reverseScaledWHPoints.x - reverseScaledPoint.x + 'px';
            myStyle.height = reverseScaledWHPoints.y - reverseScaledPoint.y + 'px';
            myStyle.zIndex = '-1000';
            fixedWriting = (<div style={myStyle} key={'originalDrawing'}>
                <img src={fixedWritingUrl} alt='' style={imagePasteImg} />
            </div>);
        }
    }

    let pointerElement;
    if (pointerData.current && pointerData.current.canvasRef) {
        let reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, 0, 0);
        let reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, drawUtils.CANVAS_ACTUAL_WIDTH, drawUtils.CANVAS_ACTUAL_HEIGHT);

        if (!reverseScaledPoint) {
            reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, 0, 0, props.email);
        }
        if (!reverseScaledWHPoints) {
            reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, drawUtils.CANVAS_ACTUAL_WIDTH, drawUtils.CANVAS_ACTUAL_HEIGHT, props.email);
        }
        if (!reverseScaledPoint || !reverseScaledWHPoints) {
            pointerElement = null;
        } else {
            let myStyle = { ...imagePasteBoxInactive };
            myStyle.position = 'absolute';
            myStyle.top = reverseScaledPoint.y + 'px';
            myStyle.left = reverseScaledPoint.x + 'px';
            myStyle.width = reverseScaledWHPoints.x - reverseScaledPoint.x + 'px';
            myStyle.height = reverseScaledWHPoints.y - reverseScaledPoint.y + 'px';
            myStyle.zIndex = '-1';
            pointerElement = (<div style={myStyle} key={'pointer'}>
                <canvas
                    width={drawUtils.CANVAS_ACTUAL_WIDTH}
                    height={drawUtils.CANVAS_ACTUAL_HEIGHT}
                    style={imagePasteImg}
                    ref={pointerData.current.canvasRef}
                />
            </div>);
        }
    }

    let auxDrawing;
    if (auxDrawingData.current && auxDrawingData.current.auxDrawingDataCanvasRef) {
        let reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, 0, 0);
        let reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, drawUtils.CANVAS_ACTUAL_WIDTH, drawUtils.CANVAS_ACTUAL_HEIGHT);

        if (!reverseScaledPoint) {
            reverseScaledPoint = drawUtils.reverseScalePoint(startPoint, 0, 0, props.email);
        }
        if (!reverseScaledWHPoints) {
            reverseScaledWHPoints = drawUtils.reverseScalePoint(startPoint, drawUtils.CANVAS_ACTUAL_WIDTH, drawUtils.CANVAS_ACTUAL_HEIGHT, props.email);
        }
        if (!reverseScaledPoint || !reverseScaledWHPoints) {
            auxDrawing = null;
        } else {
            let myStyle = { ...imagePasteBoxInactive };
            myStyle.position = 'absolute';
            myStyle.top = reverseScaledPoint.y + 'px';
            myStyle.left = reverseScaledPoint.x + 'px';
            myStyle.width = reverseScaledWHPoints.x - reverseScaledPoint.x + 'px';
            myStyle.height = reverseScaledWHPoints.y - reverseScaledPoint.y + 'px';
            myStyle.zIndex = '-1';
            auxDrawing = (<div style={myStyle} key={'auxDrawer'}>
                <canvas
                    width={drawUtils.CANVAS_ACTUAL_WIDTH}
                    height={drawUtils.CANVAS_ACTUAL_HEIGHT}
                    style={imagePasteImg}
                    ref={auxDrawingData.current.auxDrawingDataCanvasRef}
                />
            </div>);
        }
    }

    return (<>
        {lineageElement}
        {items}
        {fixedWriting}
        {auxDrawing}
        {pointerElement}
        {selectedItemCoordinates ? <RawDraggerControl
            startPoint={startPoint}
            el={{ id: 'mainStickyRotator' }}
            point={selectedItemCoordinates}
            cursor={'move'}
            icon={<RotateIconNew
                // style={{ ...rotateButton, backgroundColor: 'red' }}
                style={{ ...rotateButton, visibility: 'hidden' }}
            />}
            onDrag={(e, d) => {
                if (window.handleStickyRotationMove) {
                    window.handleStickyRotationMove(e, d);
                }
            }}
            onStop={(e, d) => {
                if (window.handleStickyRotationStop) {
                    window.handleStickyRotationStop(e, d);

                }
            }}
        /> : null}
        {selectedResizeItemCoordinates ? <RawDraggerControl
            startPoint={startPoint}
            el={{ id: 'mainStickyResizer' }}
            point={selectedResizeItemCoordinates}
            cursor={'nw-resize'}
            icon={<ResizeIcon
                // style={{ ...resizeButton, backgroundColor: 'red' }}
                style={{ ...resizeButton, visibility: 'hidden' }}
            />}
            onDrag={(e, d) => {
                if (window.handleStickyResizeMove) {
                    window.handleStickyResizeMove(e, d);
                }
            }}
            onStop={(e, d) => {
                if (window.handleStickyResizeStop) {
                    window.handleStickyResizeStop(e, d);
                }
            }}
        /> : null}

        <Dialog open={!!dialogClear} onClose={handleClose}>
            <DialogContent>
                <Typography variant='h4'>
                    <FormattedMessage id='sticky.dialog.areYouSureDelete' />
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={removeItem} onTouchStart={removeItem} color='primary'>
                    <FormattedMessage id='ok' />
                </Button>
                <Button onClick={handleClose} onTouchStart={handleClose} color='primary'>
                    <FormattedMessage id='close' />
                </Button>
            </DialogActions>
        </Dialog>
    </>);
});

export default StickyElements;
